import script from "./PhoneMyBooks.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMyBooks.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__